import React, { useState } from "react";
import {
  isLinkResendable,
  isLinkCancellable,
} from "../../../../../utils/reports/";
import { Typography, Modal, Button, Textarea } from "@plum-xoxo/admin-dsm";
import ReportService from "../../../../../services/reportService";
import { REWARD_TYPES } from "../../constants";
import moment from "moment";
import CancelReason from "../cancelReason";

const ResendAndCancel = ({
  activeTab,
  reportsData = [],
  selectedRows,
  columns,
  setColumns,
  title: initialTitle,
  selectedCategory,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [cancelReason, setCancelReasonMessage] = useState("");
  let title;

  const hasRensendableData =
    reportsData?.length &&
    selectedRows.filter((row) => isLinkResendable(reportsData[row]))?.length;
  const hasCancellableData =
    reportsData?.length &&
    selectedRows.filter((row) => isLinkCancellable(reportsData[row]))?.length;

  if (initialTitle) {
    title = initialTitle
      .toLowerCase()
      .split(" ")
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  const resend = {
    title: "Resend Email / SMS",
    subtitle: `The reward confirmation email/sms will be sent only for ${hasRensendableData} out of ${
      selectedRows.length
    } reward entries. ${
      hasRensendableData !== selectedRows?.length
        ? "The remaining are either redeemed, cancelled or expired. Do you want to proceed with the resend?"
        : ""
    } `,
  };

  const cancel = {
    title: `Cancel ${title}`,
    subtitle:
      hasCancellableData === selectedRows?.length
        ? `You have selected ${hasCancellableData} reward entries for cancellation. Do you want to proceed with the cancellation?`
        : `Out of ${
            selectedRows.length
          } reward entries selected only ${hasCancellableData} can be cancelled. The remaining are either redeemed, cancelled, expired or sent before ${moment()
            .subtract(180, "days")
            .format(
              "MMM D, YYYY"
            )}. Do you want to proceed with the cancellation?`,
  };

  const resend_success = {
    title: "Reward Email / SMS Sent!",
    subtitle: `Confirmation email/sms have been resent to ${hasRensendableData} recipient${
      hasRensendableData > 1 ? "s" : ""
    }.`,
  };

  const cancel_success = {
    title: `${title} Cancelled!`,
    subtitle: `${title} have been cancelled for  ${hasCancellableData} records. The updated status will be reflected in the corresponding record.`,
  };

  const updateReward = () => {
    let vc_id = [];

    selectedRows.map((row) => {
      if (isLinkCancellable(reportsData[row])) {
        if (title.toLowerCase() === "xoxo reward link") {
          vc_id.push(reportsData[row].link_id);
        } else {
          vc_id.push(parseInt(atob(reportsData[row].voucher_id)));
        }
      }
    });

    const params = {
      reward_type:
        title?.toLowerCase() === "xoxo reward points"
          ? 1
          : title?.toLowerCase() === "xoxo reward code"
          ? 2
          : 3,
      vc_id: JSON.stringify(vc_id),
    };

    if (selectedCategory === 1 && initialTitle === "xoxo reward link") {
      params["is_bulk"] = 1;
    }
    if (selectedOption === "cancel") {
      ReportService.bulkCancelReward(params, cancelReason).then((res) => {
        setShowConfirmationModal(false);
        setShowSuccessModal(true);
      });
    } else if (selectedOption === "resend") {
      ReportService.bulkResendRewards(params).then((res) => {
        setShowConfirmationModal(false);
        setShowSuccessModal(true);
      });
    }
  };

  return (
    selectedRows.length > 0 && (
      <div className="mr-20">
        <Typography.LabelText
          color="dark"
          shade="c200"
          className="inline-block"
        >
          {selectedRows.length} records selected.
        </Typography.LabelText>{" "}
        {hasCancellableData > 0 && (
          <>
            <Typography.LabelText
              color="primary"
              shade="c02"
              className="inline-block cursor-pointer"
              onClick={() => {
                setShowConfirmationModal(true);
                setSelectedOption("cancel");
              }}
            >
              Cancel
            </Typography.LabelText>{" "}
          </>
        )}
        {hasCancellableData > 0 && hasRensendableData > 0 && (
          <>
            <Typography.LabelText
              color="dark"
              shade="c200"
              className="inline-block"
            >
              or
            </Typography.LabelText>{" "}
          </>
        )}
        {hasCancellableData > 0 && (
          <Typography.LabelText
            color="primary"
            shade="c02"
            className="inline-block cursor-pointer"
            onClick={() => {
              setShowConfirmationModal(true);
              setSelectedOption("resend");
            }}
          >
            Resend
          </Typography.LabelText>
        )}
        <Modal
          isOpen={showConfirmationModal}
          onClose={() => {
            setShowConfirmationModal("");
          }}
          disableCloseButton={false}
          timeout={0}
        >
          <Typography.H2>
            {selectedOption === "resend" ? resend.title : cancel.title}
          </Typography.H2>
          <Typography color="dark" shade="c200" className="mt-12">
            {selectedOption === "resend" ? resend.subtitle : cancel.subtitle}
          </Typography>
          {selectedOption === "cancel" ? (
            <CancelReason
              cancelReason={cancelReason}
              setCancelReasonMessage={setCancelReasonMessage}
            />
          ) : null}
          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              variant="plain"
              className="mr-12"
              onClick={() => {
                setShowConfirmationModal("");
              }}
            >
              No, Cancel
            </Button>
            <Button color="primary" variant="fill" onClick={updateReward}>
              Yes, Proceed
            </Button>
          </div>
        </Modal>
        <Modal isOpen={showSuccessModal} timeout={0}>
          <Typography.H2 className="capatalize">
            {selectedOption === "resend"
              ? resend_success.title
              : cancel_success.title}
          </Typography.H2>
          <Typography className="mt-12">
            {selectedOption === "resend"
              ? resend_success.subtitle
              : cancel_success.subtitle}
          </Typography>
          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              variant="outlined"
              className="mr-12"
              onClick={() => {
                setShowSuccessModal(false);
                setColumns([...columns]);
              }}
            >
              OK, Got It
            </Button>
          </div>
        </Modal>
      </div>
    )
  );
};

export default ResendAndCancel;
